<template>
    <div id="home" class="main">
        <!-- 头部 -->
        <Header index="100"></Header>
        <div class="content">
            <!--[if lte IE 9]>
        <p class="browserupgrade">
          You are using an <strong>outdated</strong> browser. Please <a
          href="https://browsehappy.com/">upgrade your browser</a> to improve
          your experience and security.
        </p>
      <![endif]-->

            <!-- Add your site or application content here -->

            <!-- prealoder area start -->
            <!-- <div id="loading">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="first_object"></div>
                <div class="object" id="second_object"></div>
                <div class="object" id="third_object"></div>
                </div>
            </div>      
        </div> -->
            <!-- prealoder area end -->

            <div class="body-overlay transition-3"></div>
            <!-- extra info area end -->

            <main>
                <!-- slider area start -->
                <el-carousel class=" slider__height hidden-sm-and-down">
                    <el-carousel-item v-for="(items, index) in banner" :key="index" >
                        <div class="single-slider slider__height d-flex align-items-center " @click="gourl(items.title)"
                            data-background="../../assets/img/slider/slider-1.jpg"
                            :style="'background-image:url(' + allurl + items.image + ')'">
                            <div class="container " >
                                <div class="row">
                                    <div>
                                        <div class="slider__content" >
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </el-carousel-item>
                </el-carousel>
                <el-carousel class=" slider__height hidden-md-and-up">
                    <el-carousel-item v-for="(items, index) in banner" :key="index" >
                        <div class="single-slider slider__height d-flex align-items-center " @click="gourl(items.title)"
                            data-background="../../assets/img/slider/slider-1.jpg"
                            :style="'background-image:url(' + allurl + items.image_phone + ')'">
                            <div class="container " >
                                <div class="row">
                                    <div>
                                        <div class="slider__content" >
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </el-carousel-item>
                </el-carousel>
                
                <!-- slider area end -->

                <!-- banner area start -->
                <div class="banner__area">
                    <div class="container">
                        <div class="banner__inner mt--95">
                            <div class="row">
                                    
                                            
                                            <div class="col-xl-3  col-lg-3 col-md-3 col-xs-6"   v-for="(item, index) in goodstype" :key="index"
                                                >
                                                <div class="banner__item p-relative " >
                                                    <div class="banner__thumb fix">
                                                        
                                                            <!-- <img src="../../assets/img/shop/banner/kitchen.png" class="p-absolute" alt="banner"> -->
                                                    
                                                    </div>
                                                    <div class="transition-3">
                                                        <h5>
                                                            <a>{{ item.ex_title }} <br />
                                                                <span>{{ item.title }}</span></a>
                                                        </h5>
                                                        <div class="flex flex-sb" style="    flex-flow: column;">
                                                            <!-- <a class="link-btn">Discover now</a> -->
                                                            <!-- <div style="width:45%"> <el-button plain type="warning" round size="mini">Discover now</el-button></div> -->
                                                            <div style="width:fit-content" @click="goshop(item.id)">
                                                                <a class="link-btn">Discover now</a>
                                                            </div>
                                                            <div style="width: 100%;pisition:relative;">
                                                                <img style="width: 40%;float:right" :src="allurl + item.image"
                                                                    :alt="item.ex_title" />
                                                            </div>
                                                        </div>
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                            
                                       
                                    <!-- <div class="col-xl-20 hidden-md-and-up col-lg-4 col-md-4 col-xs-6 "   v-for="(item, index) in goodstype" :key="index">
                                        <div class="banner__item p-relative mb-30" >
                                            <div class="banner__thumb fix">
                                                
                                            </div>
                                            <div class="transition-3">
                                                <h5>
                                                    <a>{{ item.ex_title }} <br />
                                                        <span>{{ item.title }}</span></a>
                                                </h5>
                                                <div class="flex flex-sb" style="    flex-flow: column;">
                                                   
                                                    <div style="width:fit-content" @click="goshop(item.id)">
                                                        <a class="link-btn">Discover now</a>
                                                    </div>
                                                    <div style="width: 100%;pisition:relative;">
                                                        <img style="width: 40%;float:right" :src="allurl + item.image"
                                                            :alt="item.ex_title" />
                                                    </div>
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div> -->
                                  
                                
                    
                            </div>
                        </div>
                    </div>
                </div>
                <!-- banner area end -->

                <!-- product area start -->
                <section class="product__area pt-60 pb-100" v-if="product!=''">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="section__title-wrapper text-center mb-55">
                                    <div class="section__title mb-10">
                                        <h2>New</h2>
                                    </div>
                                    <div class="section__sub-title">
                                        <p>新品</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="">
                                <div class="product__slider owl-carousel">
                                    <div class="product__item col-xl-3 col-lg-3 col-md-6 col-xs-6" v-for="item,index in product" :key="index" @click="viewnews(item.id)">
                                        <div class="product__wrapper mb-60">
                                            <div class="product__thumb">
                                                <a class="w-img" ref="shopwidth">
                                                    <img :src="allurl+item.image"
                                                        alt="product-img" />
                                                    <!-- <img class="product__thumb-2"
                                                        :src="allurl+item.image"
                                                        alt="product-img" /> -->
                                                </a>
                                               
                                            </div>
                                            <div class="product__content p-relative">
                                                <div class="product__content-inner">
                                                    <h4><a class="point">{{item.ex_title}}</a>
                                                        
                                                    </h4>
                                                    <h4><a class="point">{{item.title}}</a></h4>
                                                    <div class="product__price flex flex-jb transition-3">
                                                        <div>
                                                            <span>${{item.money}}</span>
                                                            <span class="old-price">{{item.price==item.money||item.price==0?'':'$'+item.price}}</span>
                                                        </div>
                                                        <div style="padding-right:10px">
                                                              <img style="width:20px;height:20px" src="../../assets/img/bg/cart.png" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="add-cart  transition-3">
                                                    <a>+ Add to Cart</a>
                                                     
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-12">
                                        <!-- <div class="product__load-btn text-center mt-25">
                                            <a  class="os-btn os-btn-3">Load More</a>
                                        </div> -->
                                        <el-pagination
                                            @size-change="handleSizeChange"
                                            @current-change="handleCurrentChange"
                                            
                                            background
                                             :page-size="datahot.limit"
                                            layout="prev, pager, next"
                                            :total="totalhot">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="product__load-btn text-center mt-25">
                                    <a class="os-btn os-btn-3" @click="goshop()">Load More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- product area end -->

                <!-- banner area start -->
                <div class="banner__area-2 pb-60" v-if="soloshop">
                    <div class="container-fluid p-0">
                        <div class="row no-gutters">
                            <div class="col-xl-6 col-lg-6 col-sm-12 col-xs-12 "  @click="viewnews(item.id)" v-for="item,index in soloshop" :key="index">
                                
                                <div class="banner__item-2  p-relative mb-30 pr-15" :class="index%2==0?'banner-left':'banner-right'">
                                    <div class="banner__thumb fix ">
                                        <!-- w-img -->
                                        <a class=""><img :src="allurl+item.hotimage"
                                                alt="banner" /></a>
                                    </div>
                                    <div class="banner__content-2 p-absolute transition-3">
                                        <div class="product__sale">
                                    <span class="new">hot</span>
                                    <span class="percent">热销产品</span>
                                </div>
                                        <h4>{{item.ex_title}} <br/> <a style="color:#6C6C6C">{{item.title}}</a></h4>
                                        <!-- <h4></h4> -->
                                        <!-- <p>
                                            Mirum est notare quam littera gothica, quam nunc putamus
                                            <br />
                                            parum claram, anteposuerit litterarum formas.
                                        </p> -->
                                        <a class="os-btn os-btn-2">buy now / <span>${{item.money}}</span></a>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <!-- banner area end -->

                <!-- sale off area start -->
                <section class="sale__area pb-100" v-if="sales!=''">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="section__title-wrapper text-center mb-55">
                                    <div class="section__title mb-10">
                                        <h2>Specials</h2>
                                    </div>
                                    <div class="section__sub-title">
                                        <p>特价商品</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            
                                <div class="sale__area-slider owl-carousel">
                                    <div class="sale__item col-xl-4 col-lg-20 col-md-4 col-xs-6" v-for="item,index in sales" :key="index" @click="viewnews(item.id)">
                                        <div class="product__wrapper mb-60">
                                            <div class="product__thumb">
                                                <a class="w-img">
                                                    <img :src="allurl+item.image"
                                                        alt="product-img" />
                                                    <!-- <img class="product__thumb-2"
                                                        :src="allurl+item.image"
                                                        alt="product-img" /> -->
                                                </a>
                                                <!-- <div class="product__action transition-3">
                                                    <a data-toggle="tooltip" data-placement="top"
                                                        title="Add to Wishlist">
                                                        <i class="fa fa-heart"></i>
                                                    </a>
                                                    <a data-toggle="tooltip" data-placement="top" title="Compare">
                                                        <i class="fa fa-sliders"></i>
                                                    </a>
                                                    <a data-toggle="modal" data-target="#productModalId">
                                                        <i class="fa fa-search"></i>
                                                    </a>
                                                </div> -->
                                                <!-- <div class="product__sale">
                                                    <span class="new">new</span>
                                                    <span class="percent">-16%</span>
                                                </div> -->
                                            </div>
                                            <div class="product__content p-relative">
                                                <div class="product__content-inner">
                                                     <h4><a class="point">{{item.ex_title}}</a></h4>
                                                        <h4><a class="point">{{item.title}}</a></h4> 
                                                    <div class="product__price flex flex-jb transition-3">
                                                        <div>
                                                            <span>${{item.money}}</span>
                                                            <span class="old-price">{{item.price==item.money||item.price==0?'':'$'+item.price}}</span>
                                                        </div>
                                                        <div style="padding-right:10px">
                                                              <img style="width:20px;height:20px" src="../../assets/img/bg/cart.png" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="add-cart p-absolute transition-3">
                                                    <a>+ Add to Cart</a>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-12">
                                        <!-- <div class="product__load-btn text-center mt-25">
                                            <a  class="os-btn os-btn-3">Load More</a>
                                        </div> -->
                                        <el-pagination
                                            @size-change="handleSizeChange2"
                                            @current-change="handleCurrentChange2"
                                             :page-size="datacount.limit"
                                            background
                                            layout="prev, pager, next"
                                            :total="totalcount">
                                        </el-pagination>
                                    </div>
                                </div>
                           
                        </div>
                    </div>
                </section>
                <!-- sale off area end -->

                <!-- client slider area start -->

                <!-- client slider area end -->

                <!-- blog area start -->

                <!-- blog area end -->

               

                <!-- shop modal start -->
                <!-- Modal -->
                <!-- <div class="modal fade" id="productModalId" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered product-modal" role="document">
                        <div class="modal-content">
                            <div class="product__modal-wrapper p-relative">
                                <div class="product__modal-close p-absolute">
                                    <button data-dismiss="modal">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </div>
                                <div class="product__modal-inner">
                                    <div class="row">
                                        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12">
                                            <div class="product__modal-box">
                                                <div class="tab-content mb-20" id="nav-tabContent">
                                                    <div class="tab-pane fade show active" id="nav-home" role="tabpanel"
                                                        aria-labelledby="nav-home-tab">
                                                        <div class="product__modal-img w-img">
                                                            <img src="../../assets/img/shop/product/quick-view/quick-big-1.jpg"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade" id="nav-profile" role="tabpanel"
                                                        aria-labelledby="nav-profile-tab">
                                                        <div class="product__modal-img w-img">
                                                            <img src="../../assets/img/shop/product/quick-view/quick-big-2.jpg"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane fade" id="nav-contact" role="tabpanel"
                                                        aria-labelledby="nav-contact-tab">
                                                        <div class="product__modal-img w-img">
                                                            <img src="../../assets/img/shop/product/quick-view/quick-big-3.jpg"
                                                                alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <nav>
                                                    <div class="nav nav-tabs justify-content-between" id="nav-tab"
                                                        role="tablist">
                                                        <a class="nav-item nav-link active" id="nav-home-tab"
                                                            data-toggle="tab" href="#nav-home" role="tab"
                                                            aria-controls="nav-home" aria-selected="true">
                                                            <div class="product__nav-img w-img">
                                                                <img src="../../assets/img/shop/product/quick-view/quick-sm-1.jpg"
                                                                    alt="" />
                                                            </div>
                                                        </a>
                                                        <a class="nav-item nav-link" id="nav-profile-tab"
                                                            data-toggle="tab" href="#nav-profile" role="tab"
                                                            aria-controls="nav-profile" aria-selected="false">
                                                            <div class="product__nav-img w-img">
                                                                <img src="../../assets/img/shop/product/quick-view/quick-sm-2.jpg"
                                                                    alt="" />
                                                            </div>
                                                        </a>
                                                        <a class="nav-item nav-link" id="nav-contact-tab"
                                                            data-toggle="tab" href="#nav-contact" role="tab"
                                                            aria-controls="nav-contact" aria-selected="false">
                                                            <div class="product__nav-img w-img">
                                                                <img src="../../assets/img/shop/product/quick-view/quick-sm-3.jpg"
                                                                    alt="" />
                                                            </div>
                                                        </a>
                                                    </div>
                                                </nav>
                                            </div>
                                        </div>
                                        <div class="col-xl-7 col-lg-7 col-md-20 col-sm-12 col-12">
                                            <div class="product__modal-content">
                                                <h4><a>Wooden container Bowl</a></h4>
                                                <div class="rating rating-shop mb-15">
                                                    <ul>
                                                        <li>
                                                            <span><i class="fas fa-star"></i></span>
                                                        </li>
                                                        <li>
                                                            <span><i class="fas fa-star"></i></span>
                                                        </li>
                                                        <li>
                                                            <span><i class="fas fa-star"></i></span>
                                                        </li>
                                                        <li>
                                                            <span><i class="fas fa-star"></i></span>
                                                        </li>
                                                        <li>
                                                            <span><i class="fa fa-star"></i></span>
                                                        </li>
                                                    </ul>
                                                    <span class="rating-no ml-10"> 3 rating(s) </span>
                                                </div>
                                                <div class="product__price-2 mb-25">
                                                    <span>$96.00</span>
                                                    <span class="old-price">$96.00</span>
                                                </div>
                                                <div class="product__modal-des mb-30">
                                                    <p>
                                                        Claritas est etiam processus dynamicus, qui sequitur
                                                        mutationem consuetudium lectorum. Mirum est notare
                                                        quam littera gothica, quam nunc putamus parum
                                                        claram.
                                                    </p>
                                                </div>
                                                <div class="product__modal-form">
                                                    <form action="#">
                                                        <div class="product__modal-input size mb-20">
                                                            <label>Size <i class="fas fa-star-of-life"></i></label>
                                                            <select>
                                                                <option>- Please select -</option>
                                                                <option>S</option>
                                                                <option>M</option>
                                                                <option>L</option>
                                                                <option>XL</option>
                                                                <option>XXL</option>
                                                            </select>
                                                        </div>
                                                        <div class="product__modal-input color mb-20">
                                                            <label>Color <i class="fas fa-star-of-life"></i></label>
                                                            <select>
                                                                <option>- Please select -</option>
                                                                <option>Black</option>
                                                                <option>Yellow</option>
                                                                <option>Blue</option>
                                                                <option>White</option>
                                                                <option>Ocean Blue</option>
                                                            </select>
                                                        </div>
                                                        <div class="product__modal-required mb-5">
                                                            <span>Repuired Fiields *</span>
                                                        </div>
                                                        <div class="pro-quan-area d-lg-flex align-items-center">
                                                            <div class="product-quantity-title">
                                                                <label>Quantity</label>
                                                            </div>
                                                            <div class="product-quantity">
                                                                <div class="cart-plus-minus">
                                                                    <input type="text" value="1" />
                                                                </div>
                                                            </div>
                                                            <div class="pro-cart-btn ml-20">
                                                                <a class="os-btn os-btn-black os-btn-3 mr-10">+ Add to
                                                                    Cart</a>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- shop modal end -->
            </main>
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
// Import Swiper Vue.js components
//   import { Swiper, SwiperSlide } from 'swiper/vue';
import Swiper from "swiper"

  // Import Swiper styles
  
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";
import { getindex,getmessages, indexHot ,indexCount } from "@/api/index/index";

export default {
    components: { Header, Footer},
    name: "home",
    data() {
        return {
            currentIndex: "",
            totalhot:1,
            totalcount:1,
            teacherIndex: "",
            ishove: true,
            activeBtn: 2,
            clickIndex: 0,
            soloshop:[],
            goodstype: [],
            banner: [],
            product:[],
            height:'',
            sales:[],
            leftIcon: require("../../assets/left.png"),
            rightIcon: require("../../assets/right-active.png"),
            datahot:{page:1,limit:20},
            datacount:{page:1,limit:10},
            
        
        };
    },
     updated() {
        new Swiper(".swiper-container", {
        // loop: true, // 循环模式选项
        // 如果需要前进后退按钮
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        slidesPerView: 5, // 显示几个
        // height:100, // swiperlide 高度
        });
    },

    mounted() {
        this.getindex();
        this.gethot()
        this.getcount()
    },
    created() {
        //   //console.log('滚动高度', window.pageYOffset)
    },
    methods: {
        getindex() {
            getindex().then((res) => {
                //console.log(res);
                this.banner = res.banner;
                this.goodstype = res.goodstype;
                this.soloshop = res.recom 
                
               
            });
            
        },
        gethot(){
            //console.log(1)
            indexHot(this.datahot).then((res) => {
                this.product = res.hot
                this.totalhot=res.total
            });
            
        },

        getcount(){
            indexCount(this.datacount).then((res) => {
                this.sales = res.count
                 this.count=res.total
            });
        },
        gourl(url){
            // //console.log(1111111111)
            if(url){
                window.location.href = url
            }
             
        },
        viewnews(id) {
            // this.$router.push({ name: "newsview" });
            this.$router.push({ name: "productview", query: { id } });
        },
        changestyle(index) {
            this.currentIndex = index;
        },
        originstyle() {
            this.currentIndex = "";
        },
        clicktap(index) {
            this.clickIndex = index;
        },
        goshop(id){
            if(id){
                this.$router.push({ path: "/shop", query: { id } });//这里
            }else{
                 this.$router.push({ path: "/shop"});//这里
            }
            
        },
         
        arrowClick(val) {
            if (val === "right") {
                this.$refs.cardShow.next();
                //console.log(val);
                this.activeBtn = 2;
                this.rightIcon = require("../../assets/right-active.png");
                this.leftIcon = require("../../assets/left.png");
            } else {
                this.$refs.cardShow.prev();
                //console.log(val);
                this.activeBtn = 1;
                this.leftIcon = require("../../assets/left-active.png");
                this.rightIcon = require("../../assets/right.png");
            }
        },
        changehandle(currentIndex, originIndex) {
            //console.log(currentIndex, originIndex);
        },
        // 移入事件
        delHandleMouseEnter(index) {
            this.teacherIndex = index;
        },
        // 移出
        delHandleMouseleave() {
            this.teacherIndex = "";
        },
        handleSizeChange(val){
            //console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val){
            this.datahot.page=val
            this.gethot()
            //console.log(`当前页: ${val}`);
        },
        handleSizeChange2(val){
            //console.log(`每页 ${val} 条`);
        },
        handleCurrentChange2(val){
            this.datacount.page=val
            this.getcount()
            //console.log(`当前页: ${val}`);
        },
        
    },
};
</script>

<style scoped lang='less'>

.banner__area {
    z-index: 100;
}

.owl-carousel {
    display: flex;
    flex-wrap: wrap;
}

.product__area .product__thumb a {
    display: block;
}

.col-xl-20 {
    width: 20%;
}
.vh80{height:900px}
// .col-lg-20{width:20%}
.col-md-20 {
    width: 20%;
}

.col-xs-6 {
    width: 50%;
}

/deep/ .el-carousel__container{
    height:100%
}
/deep/ .el-carousel__button{
   height:10px 
}


/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #bc8246;
}
//  .col-xl-20
.sale__item a {
    // display: block;
    
}


.banner__area-2 .banner__thumb{ 
    background:#f5f5f5;
    margin:10px;
    min-height:200px
}
 .w-img img{height:100%}
.transition-3{text-align: left;}
.banner__area-2 .banner__thumb img{
    height:100%;width:100%;
    max-height: 450px;
}
.slider__content {padding:10px;max-width: 550px;}
 .w-img {height:310px}
.sale__item  .w-img {height:245px}
  
.swiper-container {
//   width: 350px;
  --swiper-navigation-size: 40px;/* 设置按钮大小 */
 --swiper-navigation-color: #bc8246;/* 单独设置按钮颜色 */
}
.swiper-button-next{right:-30px;font-size: 30px;transform:translate(50%, -50%);color: #bc8246}
.swiper-button-prev{left:-30px;font-size: 30px;transform: translate(50%, -50%);color: #bc8246}
.product__thumb .w-img img:hover{transform: scale(1.1)}
.content{background:#f1f1f1}
// .sale__area{background:#f1f1f1}
.product__area .product__slider>.col-xs-6{width:50%}
.product__item{padding:5px;margin:0}

.product__item .product__wrapper{background:#fff;border-radius: 5px;overflow: hidden;}
 .product__content{padding:5px 10px}
.product__wrapper{background:#fff;border-radius: 5px;overflow: hidden;}
.section__title h2{background:#f1f1f1}
.sale__item{padding:5px;margin:0}

.banner__item {
    padding: 10px;
    width: 100%;
    background: #f5f5f5;
    text-align: left;
    margin:10px 0
}

.link-btn {
    border: 1px solid #bc8246;
    border-radius: 10px;
    padding: 1px 2px;
    white-space: nowrap;
    text-transform: none;
}
.banner__area{margin:0;}
.banner__area-2 .product__sale{
    transform:rotate(0);
    right:0;
    left:10%;
}
.banner__area-2 .product__sale  span{
    background: #9d2e13;
}
.banner__area-2 .product__sale  span.percent{
    background: #201f1f;
}

.banner__area-2 .product__sale .new::before{
    border: 5px solid #9d2e13;
    border-color: #9d2e13 transparent transparent #9d2e13;
    border-width: 9px 5px;
}
.banner__inner .row::-webkit-scrollbar{
	display:none;
} 

.banner__inner .row>div{
//   padding-top: 15px;
}
.banner__area-2 .product__sale .new::after{
    border: 5px solid #9d2e13;
    border-width:9px 5px;
    border-color: transparent transparent #9d2e13 #9d2e13;
}
.product__wrapper{cursor: pointer;}
.product__content-inner  h4 {white-space: nowrap;text-overflow: ellipsis;overflow: hidden;text-align: left;}

.banner__area .transition-3{padding:0}
.banner__area .transition-3 h5{margin-bottom: 10px;}
.banner__area .transition-3 h5 a{padding: 0 !important;}
// /deep/ .el-carousel__item .single-slider{height:100%} 
.banner__area-2 .transition-3{width:90%}
.banner__area-2 .transition-3 h4{width:65%}


.product__price{padding:10px 0;align-items: center; }

.product__sale{position: relative;top:0;left:0!important;margin-bottom:20px}
// .single-slider{bac}
// .mt--95{margin-top: -150px;}
// @import "../../assets/css/preloader.css";
// @import "../../assets/css/bootstrap.min.css";
// @import "../../assets/css/slick.css";
// @import "../../assets/css/owl.carousel.min.css";
// @import "../../assets/css/animate.min.css";
// @import "../../assets/css/jquery.fancybox.min.css";
// // @import "../../assets/css/fontAwesome5Pro.css";
// // @import "../../assets/css/ionicons.min.css";
// @import "../../assets/css/default.css";
// @import "../../assets/css/style.css";

@import "../../../static/swiper.css";
// .swiper-container{
// 	height: 80px;
// 	padding-left: 56px;
// 	background-image: -webkit-radial-gradient(23% 100%, #2e79c3 0%, #297bc4 100%);
// }
// .swiper-slide{
// 	width: auto!important;
// 	display: inline-block;
// 	margin-right: 40px;
// 	height: 80px;
// 	line-height: 80px;
// 	font-size: 32px;
// 	padding: 0 15px;
// 	-webkit-box-sizing: border-box;
// 	box-sizing: border-box;
// 	text-align: center;
// 	color: #fff;
// 	cursor: pointer;
// }
// 	.swiper-container .swiper-slide .active {
// 		color: #666;
// 		background-color: #fff8eb;
// 		box-shadow: 0 3px 13px 0 rgba(94, 94, 94, 0.50);
// 	}
// .subscribe__form input{border:none!important;margin-bottom:0!important}


@media (max-width: 1200px) {
    
    .banner__area .transition-3 h5 a{font-size: 16px !important;white-space: nowrap;}
    .sale__item  .w-img {height:198px}
}   
      
@media (max-width: 990px) {
    
     .w-img {height:390px}
     .sale__item  .w-img {height:253px}
}
@media (min-width:480px) and (max-width:767px) {
    .w-img{
        height:285px
    }
    .sale__item  .w-img {height:285px}
}
@media (max-width: 488px) {
    .banner__area .transition-3 h5 a{font-size: 14px !important;}
     .banner__area .banner__inner{padding:0}
    .pb-100{padding-bottom: 50px;}
    .w-img{
        height:200px
    }
    .banner__area .banner__item{margin:5px 0;} 
    .banner__inner .row{padding:10px}
     .product__wrapper{margin-bottom:0}
      .product__thumb{margin-bottom:0}
    .slider__height{height:500px}
     .banner__area-2 .banner__thumb img{height:220px}
    .sale__item  .w-img {height:200px}
    .vh80{height:300px}
    .product__sale{top:20px} 
   
    .slider__content p{margin-bottom:0;text-align: left;}
}
@media (min-width:375px) and (max-width:400px) {
    .slider__height{height:450px}
    .w-img{
        height:180px
    }
    .sale__item  .w-img {height:180px}
   
}
@media (min-width: 990px) {
      .banner__area-2 .banner__thumb img{height:22vw}
    .col-md-20 {
        -ms-flex: 0 0 20%;
        -webkit-box-flex: 0;
        flex: 0 0 20%;
        max-width: 20%;
    }

    .col-lg-20 {
        -ms-flex: 0 0 20%;
        -webkit-box-flex: 0;
        flex: 0 0 20%;
        max-width: 20%;
    }

    .col-xl-20 {
        -ms-flex: 0 0 20%;
        -webkit-box-flex: 0;
        flex: 0 0 20%;
        max-width: 20%;
    }
}



@media (min-width:480px) {
  
    
}
@media (min-width: 768px) {
     .banner__area-2 .banner__thumb img{height:46vw}
    .col-md-20 {
        -ms-flex: 0 0 20%;
        -webkit-box-flex: 0;
        flex: 0 0 20%;
        max-width: 20%;
    }
    
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue